module.exports = __webpack_public_path__ + "img/gift-gray.6f85cd68.svg";